define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var Backbone = require('backbone');
    var _ = require('underscore');
    var AppConfig = require('config/application');

    return Marionette.ItemView.extend({
        template: '<div class="fa fa-bell-o js-news-counter"><span class="badge badge-important">{{#if counter}} {{ counter }} {{/if}}</span></div>',

        events: {
            'click': 'onClickCounter'
        },

        initialize: function () {
            this.listenTo(app.Models.User, 'change:news_counter', this.render);
        },

        onClickCounter: function() {
            app.Models.User.set('news_counter', 0);
            this.decrementCounter();
            Backbone.history.navigate('#news', true);
        },

        decrementCounter: function() {
            return Backbone.ajax({
                type: 'POST',
                url: AppConfig.host + '/rest/system/decrease_news_counter',
            })
        },

        serializeData: function() {
            return {
                counter: app.Models.User.get('news_counter')
            }
        },


    });
});